import { Component, Renderer2, Inject, ChangeDetectionStrategy } from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  MarketDataEventTransformer,
  RateSubscriptionPromiseService,
  TraderGroupPromiseLookupService,
  RateCache,
  CcyPairPromiseLookupService,
  RatePromiseService,
  CurrencyPairCalendarPromiseLookupService,
  SystemConfigPromiseService,
  BranchLookupService,
  ClientLookupService,
} from "shared/cubiq-services";

import { TranslateService } from "@ngx-translate/core";
import { OESettingsService } from "../services/basic/oe-settings.service";
import { OECoordinatorService } from "../services/oe-coordinator.service";
import { OEApiService } from "../services/oe-api.service";
import { OEUtilityService } from "../services/basic/oe-utility.service";

import {
  INPUT_TIME_SHOWSECONDS,
  INPUT_TIME_PATTERN,
  SECS_VALIDATE_TIME_PATTERN,
  SECS_MASK,
  INPUT_TIME_MASK,
  INPUT_TIME_DEFAULT,
  SECS_DEFAULT,
} from "./controls/bfx-time-input.component";
import { OELoggerService } from "../services/basic/oe-logger.service";
import { BfxConfigService } from "shared/auth-services/system-config/bfx-config.service";
import { OEDatasetService } from "app/order-entry/services/basic/oe-dataset.service";
import { OEAlgoEntryComponent } from "./oe-panel-algo-entry.component";
import { OEDLoadingDataModel } from "../data/models/oe-loading-data.model";
import { OENInputControl } from "../data/enums/oe-input-control.enum";
import { ICTenorValueDateModel } from "./controls/models/bfx-interface-controls.models";
import { OEPanelNdfAlgoModel } from "../data/models/oe-panel-ndf-algo.model";

import { LoggerService } from "@bfx/logger";
import { OENLockedState } from "../data/enums/oe-locked-state.enum";
import { OEAdapterForwardService } from "../services/adapter/oe-adapter-forward.service";
import { OEModelGetterService } from "../services/model/oe-model-getter.service";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "oe-panel-ndf-algo-entry",
  templateUrl: "./html/oe-panel-algo-entry.html",
  providers: [
    { provide: INPUT_TIME_SHOWSECONDS, useValue: true },
    { provide: INPUT_TIME_PATTERN, useValue: SECS_VALIDATE_TIME_PATTERN },
    { provide: INPUT_TIME_MASK, useValue: SECS_MASK },
    { provide: INPUT_TIME_DEFAULT, useValue: SECS_DEFAULT },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OENdfAlgoEntryComponent extends OEAlgoEntryComponent {
  constructor(
    translate: TranslateService,
    settings: OESettingsService,
    coordinator: OECoordinatorService,
    traderGroupService: TraderGroupPromiseLookupService,
    getter: OEModelGetterService,
    forwardAdapter: OEAdapterForwardService,
    utility: OEUtilityService,
    api: OEApiService,
    cd: ChangeDetectorRef,
    rateService: RatePromiseService,
    rateCache: RateCache,
    rateTransformer: MarketDataEventTransformer,
    rateSubscriptionService: RateSubscriptionPromiseService,
    currencyPairService: CcyPairPromiseLookupService,
    calendarService: CurrencyPairCalendarPromiseLookupService,
    oeLogger: OELoggerService,
    renderer2: Renderer2,
    sysConfigService: SystemConfigPromiseService,
    configService: BfxConfigService,
    branchLookupService: BranchLookupService,
    clientLookupService: ClientLookupService,
    datasetService: OEDatasetService,
    @Inject(INPUT_TIME_SHOWSECONDS) in_showSeconds: boolean,
    @Inject(INPUT_TIME_MASK) in_mask: string,
    @Inject(INPUT_TIME_PATTERN) in_pattern: RegExp,
    @Inject(INPUT_TIME_DEFAULT) in_default: string,
  ) {
    super(
      translate,
      settings,
      coordinator,
      traderGroupService,
      getter,
      forwardAdapter,
      utility,
      api,
      cd,
      rateService,
      rateCache,
      rateTransformer,
      rateSubscriptionService,
      currencyPairService,
      calendarService,
      oeLogger,
      renderer2,
      sysConfigService,
      configService,
      branchLookupService,
      clientLookupService,
      datasetService,
      in_showSeconds,
      in_mask,
      in_pattern,
      in_default,
    );
    this.oeLogger = oeLogger.for(__dirname);
    this.isNDFAlgo = true;
  }

  /**
   * define type-specific visibility - e.g. NDF algos do not have autoFwdpricing
   */
  protected override initControlVisibility(): void {
    this.data.autoFwdPricing.show = false;
  }
}
